export default {
  'AUTH': {
    'CONFIRM_PASSWORD': 'Confirmez le mot de passe',
    'EMAIL': 'Email',
    'EMPTY_EMAIL': 'Le courrier électronique ne peut pas être vide.',
    'EMPTY_PASSWORD': 'Le mot de passe ne peut être vide.',
    'FORGOT_PASSWORD': 'Mot de passe oublié',
    'INVALID_EMAIL': "S'il vous plaît fournir un email valide.",
    'INVALID_PASSWORD': 'Le mot de passe doit avoir au moins {MINIMUM} caractères.',
    'IDENTICAL_PASSWORD': 'Les mots de passe doivent être identiques.',
    'LINK_EXPIRED': 'Le lien a expiré.',
    'LINK_USED': "Quelqu'un a déjà utilisé ce lien. Si ce n'est pas vous, veuillez réinitialiser le mot de passe à nouveau.",
    'LOGIN': "S'identifier",
    'NEW_PASSWORD': 'nouveau mot de passe',
    'PASSWORD': 'Mot de passe',
    'PASSWORD_UPDATED': 'Mis à jour avec succès le mot de passe.',
    'RESET_LINK_SENT': "Le lien de réinitialisation a été envoyé à l'e-mail enregistré.",
    'RESET_PASSWORD': 'réinitialiser le mot de passe',
    'SUBMIT': 'Soumettre',
    'USER_LOGIN': 'Utilisateur en ligne',
    'USER_NOT_FOUND': "Aucun utilisateur trouvé. S'il vous plaît contacter admin.",
    'PWD_CHANGE': 'changer le mot de passe',
    'PWD_CURRENT': 'Mot de passe actuel'
  },
  'ERROR': {
    'COMMON': 'Erreur est survenue. Veuillez réessayer.'
  },
  'HEADER': {
    'TRIAL_USER': "Vous êtes un utilisateur à l'essai. La période d'essai se termine le {END_DATE}.",
    'NOTIFY_MSG': 'Vous avez {len} notifications',
    'CLEAR': 'Clair',
    'TEMPLATES': 'Modèles',
    'FORMS': 'Formes',
    'UPLOAD_FORM': 'Formulaire de téléchargement',
    'REPORTS': 'Rapports',
    'PROFILE': 'Profil',
    'USERS': 'Utilisateurs',
    'LOGS': 'Les journaux',
    'SETTINGS': 'Réglages',
    'LOGOUT': 'Connectez - Out',
    'ACCOUNTS': 'Comptes',
    'MODELS': 'DES MODÈLES',
    'Features': 'Caractéristiques'
  },
  'TEMPLATE': {
    'DATE_FORMAT': 'Format de date',
    'ADD_NEW': 'Ajouter un nouveau modèle',
    'ENABLE_AUTO_CORRECT': 'Activer la correction automatique: ',
    'CLONE': 'Cloner un modèle depuis un autre compte.',
    'CREATE_NPI_GROUP': 'Créer un groupe NPI',
    'DATA_TYPE': 'Données Type',
    'DELETE_CONTENT': "Voulez-vous supprimer ce '{TEMPLATE_TITLE}' modèle?",
    'DELETE_MAP': 'Effacer Mapping (Cmd + d)',
    'DELETE_MODAL': 'Supprimer les mappages',
    'DELETE_MODAL_CONTENT': 'Êtes-vous sûr de vouloir supprimer le champ?',
    'DRAW': 'Dessiner',
    'DISABLE_FORM': 'Désactiver pour la soumission de formulaire',
    'ENABLE_FORM': 'Activer pour la soumission de formulaire',
    'ENTER_TITLE': 'Entrez titre....',
    'ENTER_DESCR': 'Entrez modèle description',
    'GRP_NAME': 'Groupe Prénom',
    'GRP_TYPE': 'Groupe Type',
    'REDACT_FIELD': 'Redact Field',
    'SHOW_FIELD': 'Show Field',
    'KEY': 'Clé',
    'MAPPING_CATEGORY': 'Catégorie',
    'MAPPINGS': 'Cartographies:',
    'CASE': 'Cas',
    'MSG_ADDED': 'Modèle ajouté avec succès',
    'MSG_REMOVED': 'Modèle Supprimé avec succès..',
    'MSG_SAVED': "Les modifications de l'éditeur sont enregistrées avec succès.",
    'MSG_SAVE_FAIL': 'Quelque chose a mal tourné. Échec de la sauvegarde...',
    'NEXT_PAGE': 'Aller à page suivante',
    'NOTHING': 'No se encontraron plantillas!',
    'NPI_GROUP': 'NPI Groupe',
    'OLDER_VERSIONS': 'Les anciennes versions ne peuvent pas être modifiées',
    'PREV_PAGE': 'Aller à page précédente',
    'ESMMAPPINGS': 'Mappages de services externes',
    'TEMPLATE_VERSION_UPDATE': 'Voulez-vous cloner les mappages de champs dans l"écran de mappage de service vers une nouvelle version de modèle?',
    'ESM_CLONING': 'Les mappages de services externes seront clonés',
    'ORTF_CLONING': 'Les mappages ORTF seront clonés',
    'SV_CLONING': 'Les validations de service seront clonées',
    'Hl7_CLONING': 'Les mappages HL7 seront clonés',
    'CV_CLONING': 'Les mappages Custom Validations seront clonés',
    'REDO': 'Refaire (Cmd + Shift + z)',
    'REQ': 'Obligatoires',
    'REQ_TYPE': 'Sélectionner type de processus',
    'REQ_FILE': 'Le fichier ne peut pas être vide',
    'REQ_TITLE': 'Le titre ne peut pas être vide',
    'SAVE': 'Sauvegarder (Cmd + s)',
    'SAVE_CHANGES': "Aimez-vous enregistrer les modifications avant de quitter l'éditeur?",
    'SELECT': 'Sélect (Esc)',
    'SELECT_DATA_TYPE': 'Veuillez sélectionner le type de données',
    'SELECT_DATE_FORMAT': 'Veuillez sélectionner le format de date',
    'SELECT_TYPE': 'Veuillez sélectionner le type',
    'SELECT_FROM_ACCOUNT': 'Du compte',
    'SELECT_TO_ACCOUNT': 'Estimer',
    'SELECT_ACCOUNT': 'Sélectionner un compte',
    'SELECT_TEMPLATE': 'Choisir un modèle',
    'SELECT_CASE': 'Sélectionnez le cas',
    'TEMPLATE': 'Modèle',
    'THUMBNAIL': 'La vignette',
    'THEME': 'Thème',
    'TRAIN': 'Train',
    'TRAIN_BASE': 'Train Base Template:',
    'TYPE': 'Type',
    'UPDATE_MAP': 'Mise à jour du Mappage',
    'UPDATE_GRP': 'Groupe de mise à jour',
    'UNDO': 'Annuler (Cmd + z)',
    'UNSAVE': 'Changements non enregistrés',
    'ZOOM_IN': 'Zoom avant (Cmd + +)',
    'ZOOM_OUT': 'Zoom arrière (Cmd + -)',
    'IMPORT': 'Importer',
    'EXPORT': 'Exportation',
    'UPLOAD_MAPPINGS': 'Télécharger le fichier de mappages'
  },
  'TEMPLATE_VIEW': {
    'ID': 'ID',
    'PAGES': ' PAGE(S)',
    'TOTAL_PAGES': 'Pages totales',
    'UPDATED_AT': 'Updated à',
    'VIEW': 'VUE:'
  },
  'DATA_TYPE': {
    'ALPHA': 'Alphabets',
    'ALPHANUM': 'Alphanumérique',
    'ALPHANUMSPC': 'Alphanumérique With Spaces',
    'BLOCK': 'Bloc',
    'CHECKBOX': 'Case à cocher',
    'CITY': 'Ville',
    'COMBINE_DATA': 'Combiner des données',
    'CHECKBOX_TEXT': 'Texte de la case à cocher',
    'DATE': 'Rendez-vous amoureux',
    'DEFAULT': 'Défaut',
    'EITHER': 'Ou-ou Choix',
    'LOGICAL': 'Logique',
    'MULTI_CHOICE': 'Plusieurs Choix',
    'NPI': 'NPI',
    'NUMERIC': 'Numérique',
    'STATE': 'État',
    'TABLE_COLUMN': 'Tableau ( Données de colonne )',
    'TABLE_ENTRY': 'Entrée de table',
    'TABLE_HEADER': 'En-tête de table',
    'TABLE_ROW': 'Tableau ( Données de ligne )',
    'TEXT': 'Texte',
    'ZIPCODE': 'Code postal',
    'CAPITALIZE': 'Mettre en majuscule la première lettre de champ',
    'UPPER_CASE': 'Haut de casse',
    'LOWER_CASE': 'Minuscules'
  },
  'COLOR': {
    'BLUE': 'Bleu',
    'GREEN': 'Vert',
    'RED': 'Rouge'
  },
  'UPLOAD_DROPDOWN': {
    'ENROLLMENT_FORMS': 'Formulaires d\'inscription',
    'SELECT': 'Sélectionner',
    'AUTO': 'Match automatique',
    'PLAIN': 'Texte brut',
    'INSURANCE': 'Carte d\'assurance',
    'INSU_F_B': 'Cartes d\'assurance recto et verso',
    'MANUAL': 'Manuel',
    'DL': 'Permis de conduire/ID électeur',
    'INVOICE': 'Facture d\'achat',
    'EXCEL': 'Classeur Excel',
    'LEASE': 'Document de location',
    'SLA': 'Contrat de licence de logiciel',
    'AUS_LEASE': 'Document de location australien',
    'BIOTRONIK': 'Biotronik',
    'MEDTRONIC': 'Medtronic',
    'MEDTRONIC2': 'Medtronic-2',
    'BOSTON': 'Boston Scientific',
    'TRIAGING': 'sorting'
  },
  'FORMS': {
    'ROTATE_LEFT': 'Tourne à gauche',
    'ROTATE_RIGHT': 'Tourner à droite',
    'IMAGE_ROTATE_SUCCESS': 'Rotation d"image réussie',
    'IMAGE_ROTATE_FAIL': 'La rotation de l"image a échoué',
    'MULTI_USER_MODAL': 'ATTENTION',
    'MULTI_USER_ALERT_MSG': 'Actuellement, un autre utilisateur consulte ce document. Veuillez valider un autre document',
    'ACCEPT_PERMISSION_ERROR': 'Impossible d"accepter l"autorisation de formulaire requise!',
    'NEXT_FORM': '<< Document suivant',
    'PREV_FORM': 'Document précédent >>',
    'SELECT_MODEL': 'Sélectionnez le modèle',
    'MODEL_NAME': 'Nom du modèle',
    'MODEL_NAME_ERR': 'Le nom du modèle ne peut pas être vide',
    'USE_TITLE': 'Utilisez le même titre pour tous les formulaires',
    'CONF_RANGE': 'Gamme de confiance',
    'CHECK_ELIG_BTN_LABEL': 'Vérifier l\'éligibilité',
    'CHECK_ELIG_SUCC_MESSAGE': 'Contrôle d\'admissibilité réussi',
    'CHECKING_ELIG_BTN_LABEL': 'Vérification de l\'admissibilité',
    'AVG_CONF': 'Confiance moyenne',
    'COMP_IMAGES': 'Comparer avec les images téléchargées',
    'NO_LINE_ITEMS': 'Aucun élément de ligne à afficher ...',
    'AUTO_CORRECT': 'Correction automatique',
    'AUTO_CORRECT_CONTENT': 'La valeur mise à jour sera utilisée ultérieurement, êtes-vous sûr de vouloir enregistrer?',
    'ACCEPT': 'Acceptez',
    'VERIFY': 'Vérifier',
    'APPROVED': 'APPROUVÉ',
    'ADD_FIELD': 'Ajouter Field',
    'ALL': 'Pour toutes les formes',
    'CON_SCORE': 'Confiance Score',
    'CHANGE_LABEL': 'Changer Etiquette',
    'CHOOSE': 'Choisissez un formulaire...',
    'DELETE_CONTENT': 'Voulez-vous supprimer ce {FIELD_NAME} field?',
    'DESCRIPT_PLACE': 'Entrez formulaire description',
    'DROP_SCANNED': 'Cliquez ici / Glissez-déposez les fichiers ici pour les traiter',
    'DROP_TEMP_SCANNED': 'Cliquez ici / glissez et déposez les fichiers à télécharger',
    'EDITED': 'EDITED',
    'EXPORT_ERROR': "Erreur de mappage d'exportation Salesforce",
    'FORCED_TEMPLATE': 'Modèle forcé',
    'LABEL': 'Etiquette',
    'LABEL_NAME': 'Etiquette Nom',
    'MATCH': 'Rencontre',
    'MATCHING_TEMPLATE': 'Voir le modèle correspondant',
    'MSG_ACCEPT': 'Formulaire accepté',
    'MSG_DEL': 'Données supprimées avec succès',
    'MSG_LABEL': 'Étiquette modifiée avec succès',
    'MSG_SUCESS': 'Données mises à jour avec succès',
    'MSG_WARN': "Le formulaire de téléchargement n'est pas traité",
    'NOTHING': 'Aucune donnée à afficher...',
    'ONLY': 'Seulement pour ce formulaire',
    'PENDING': 'EN ATTENDANT',
    'PAGES_WITH_DATA': 'Pages avec données',
    'PROCESS_TYPE': 'Type de processus',
    'PROCESSED_DATA': 'Données traitées',
    'PROCESSING_STAT': 'Les formulaires téléchargés sont en cours de traitement ... Veuillez patienter',
    'PROCESSED_STAT_ONE': 'Le nouveau formulaire a été traité. Cliquez pour rafraîchir',
    'PROCESSED_STAT_MANY': 'Les nouveaux formulaires ont été traités. Cliquez pour rafraîchir',
    'REJECTED': 'REJECTED',
    'REQ_TITLE': 'Titre ne peut pas être vide',
    'REQ_LABEL': 'Nom ne peut pas être vide',
    'REQ_FILE': 'Fichier ne peut pas être vide',
    'SELECT_PAGE_NUM': 'Page: ',
    'TABLE_DATA': 'Données de table',
    'TEMPLATE': 'Modèle',
    'TITLE_PLACE': 'Titre du formulaire...',
    'UPLOAD_PROCESS': 'Téléchargement et Traitement...',
    'UPLOADING': 'Téléchargement ...',
    'UPLOAD_A_FORM': 'Télécharger un formulaire scanné',
    'UPLOAD_MULTI_FORMS': 'Télécharger formulaires numérisés',
    'VALUE': 'Valeur',
    'VALIDATION_HEADER': 'Veuillez corriger / corriger les champs suivants',
    'VALIDATE_SIGNATURE': 'Veuillez approuver / rejeter la signature pour vérifier',
    'VALIDATIONS': 'Erreurs de validation',
    'REQUIRED_FIELDS_VALIDATION': 'Erreurs de champs obligatoires',
    'SERVICE_VALIDATION': 'Erreurs de validation de service',
    'VALIDATION_ERROR': 'Erreurs de validation',
    'OPTIONAL_FIELDS_VALIDATION': 'Erreurs de champs optionnels'
  },
  'WORKFLOW': {
    'LOCK_TITLE': 'Verrouillé par {userName}',
    'LOCK_ALERT_MSG': '¿Quieres desbloquear este registro? ?',
    'ACTIONS': 'Actes',
    'ANALYSE': 'Analyser',
    'ANALYSIS': 'Une analyse',
    'TITLE': 'Nom du patient',
    'INVOICE': "Facture d'achat",
    'DOWNLOAD': 'Télécharger',
    'FILTER': 'filtres',
    'FILTERS': 'Filtres',
    'MATCH': 'Rencontre',
    'GROUP_ID': 'ID du groupe',
    'PROCESSED_FORMS': 'Formulaires traités',
    'PROCESS_PAGE_COUNT': 'Nombre de pages traitées',
    'MATCHED_PAGE_COUNT': 'Nombre de pages assorties',
    'REJECT_PAGE_COUNT': 'Nombre de pages rejetées',
    'SEARCH': 'Type à Rechercher',
    'UPDATED_AT': 'Updated à',
    'DELETE_FORM': "Voulez-vous supprimer ce formulaire '{FORM_TITLE}'?",
    'FAX_NUMBER': 'Numéro de fax',
    'ENTER_FAX_NUMBER': 'Entrez le numéro de fax',
    'DELETE': 'Effacer',
    'FORM_INFO_HEADER': 'Détails des formulaires traités',
    'DELETE_MULTIPLE': 'Supprimer les formulaires multiples',
    'REPROCESS': 'Retraiter',
    'MAX_RETRIES': 'Atteint le nombre de tentatives maximum.',
    'MOVE_TO_MATCHED': 'Déplacer vers la file d\'attente correspondante',
    'STATUS': 'Statut',
    'DOCUMENT_TYPE': 'Type de document',
    'PRODUCT': 'Produit',
    'REPORT': 'Signaler'
  },
  'ANALYTICS': {
    'TOTAL_FORMS': 'Total des formulaires reçus',
    'CONFIDENCE': 'Confiance (%)',
    'CONFIDENCE_AVG': 'Valeur de confiance de la page modèle (%)',
    'DAILY_REPORT': 'Rapport journalier',
    'FILTER_TEMPLATES': 'Filtrer par modèles',
    'FORM_WORKFLOW_STATS': 'Statistiques de flux de travail de formulaire',
    'IDENTIFIED': 'Identifié',
    'RECENT_FORMS': 'Formulaires récents',
    'FAXES_RECEIVED': 'Nombre total de Formes de patients reçus',
    'FAXES_IDENTIFIED': 'Nombre total de Formes de patient identifiés',
    'FAXES_READABLE': 'Nombre total de Formes patient lisibles',
    'FAXES_REJECTED_ORIGIN': 'Formulaires de patients totaux rejetés selon le pays',
    'FAXES_REJECTED_BY_REASON': 'Nombre total de formulaires de patients rejetés en raison de leur lisibilité',
    'FAXES_UNPROCESSED': 'Nombre total de formulaires patient non associés au modèle',
    'REJECTED': 'Raison rejetée',
    'WEEKLY_REPORT': 'Rapport hebdomadaire',
    'TOTAL_PROCESSED': 'Traité',
    'TOTAL_REJECTED': 'Rejeté',
    'TEMPLATE': 'Modèle',
    'PROCESS_TYPE': 'Type de processus',
    'SELECT_PROCESS_TYPE': 'type processus',
    'PAGES': 'Pages',
    'RECENT_FORM_MSG': 'Les formulaires récents générés dans le fichier CSV nappartiendront quà la plage de dates sélectionnée.',
    'REPORT_CONTENT': 'Signaler le contenu'
  },
  'CONFIGURED': {
    'ADD_ROLE': 'Ajouter Rôle',
    'ADD_GROUP': 'Ajouter un champs',
    'ADD_ALIAS': 'Ajouter un alias',
    'ADD_FIELD_ALIAS': 'Ajouter des alias de champs',
    'ADD_NEW_KEYS': 'Ajouter de nouvelles clés',
    'B_PREVIEW': 'Bordure Aperçu',
    'CONFIDENCE_COLORS': 'Couleurs de confiance',
    'CC_SUCCESS': 'Les couleurs de confiance sont mises à jour avec succès',
    'COLOR': 'Couleur',
    'CREATE': 'Créer',
    'IMPORT_MAPPINGS': 'Importer des mappages',
    'EDIT_GROUP': 'Editer le groupe',
    'EDIT_ALIAS': 'Modifier lalias',
    'FORM_ORDER': 'Ordre de traitement de formulaire',
    'FIELD_TYPE': 'Type de champ',
    'FIELD_EXISTS': 'Déjà le champ existe',
    'FIELDS': 'Des champs',
    'FIELDS_ALIASES': 'Alias de terrain',
    'NEW_ROLE': 'Nouveau rôle',
    'NOTE': "Remarque: Glissez / déposez les éléments pour modifier l'ordre de traitement du formulaire",
    'PREVIEW': 'Aperçu',
    'PROCESS_ORDER_SUCCESS': 'Ordre de traitement mis à jour avec succès',
    'RANGE': 'Gamme',
    'ROLE_CREATED': ' le rôle est créé avec succès',
    'ROLE_MANAGE': 'Rôles La gestion',
    'ROLE_NAME': 'Nom de rôle',
    'ROLE_NOTE': "Remarque: Glissez / déposez les éléments pour modifier l'ordre des rôles.",
    'ROLE_ORDER': 'Ordre de Rôle ',
    'ROLE_ORDER_SUCCESS': "L'ordre des rôles est mis à jour avec succès",
    'ROLE_SUCCESS': 'Les rôles sont mis à jour avec succès',
    'SELECT_ROLE': 'Sélectionner un rôle',
    'PROCESS_TYPE': 'Types de processus abonnés',
    'FIELD': 'Nom de domaine',
    'SUBSCRIBE_MODAL': 'Souscrire un nouveau type de processus',
    'UNSUBSCRIBE_MODAL': 'Se désabonner d\'un type de processus',
    'SUBSCRIBE_PT': 'Abonné avec succès un nouveau type de processus',
    'UNSUBSCRIBE_PT': 'Désabonné avec succès',
    'ENTER_SECTION_NAME': 'Entrez le nom de la section',
    'SECTION_ORDER': 'Ordre des sections',
    'SECTION_NOTE': "Remarque: faites glisser / déposez les éléments pour modifier l'ordre des sections",
    'SECTION_ORDER_SUCCESS': "L'ordre des sections a été mis à jour avec succès",
    'HL7_TEMPLATES': 'Modèles HL7'
  },
  'TRAILS': {
    'AUDIT_TRAILS': 'Des pistes de vérification',
    'LOGGED_AT': 'Enregistré à',
    'LOCATION': 'Emplacement',
    'PATH': 'Chemin',
    'CUSTOM_DATE_LOGS': 'Journaux de date personnalisés'
  },
  'USERS': {
    'ACCOUNT': 'Compte',
    'ADD_NEW': 'Ajouter de nouveaux utilisateurs',
    'EMAIL': 'Email',
    'PASSWORD': 'Mot de passe',
    'PASS_CONFIRM': 'Confirmation mot de passe',
    'REPEAT': 'Répéter de passe',
    'LINK': 'Lien',
    'LIST': 'Liste des utilisateurs',
    'LOGOUT': 'Logout',
    'REQ_USERNAME': "Nom d'utilisateur ne peut pas être vide",
    'REQ_MIN_LENGTH': "Le nom d'utilisateur doit comporter au moins 5 caractères",
    'REQ_ONLY_ALPHANUM': "Le nom d'utilisateur ne peut être que des caractères alphanumériques",
    'REQ_EMAIL': 'Email ne peut pas être vide',
    'REQ_VALID_EMAIL': 'Veuillez fournir une adresse email valide',
    'REQ_PASS': "Mot de passe d'utilisateur ne peut pas être vide",
    'REQ_PASS_MIN_LENGHT': 'Le mot de passe doit comporter au minimum 8 caractères',
    'REQ_NO_MATCH': 'Le mot de passe et le mot de passe répété ne correspondent pas',
    'REQ_ACCOUNT': 'Le Compte ne peut pas être vide',
    'CREATE_ROLE': 'Au moins un rôle doit être créé dans les paramètres pour créer des utilisateurs.',
    'REQ_ROLE': 'Le Rôle ne peut pas être vide',
    'ROLE': 'Rôle',
    'ROLES': 'Rôles',
    'SELECT_ROLE': 'Veuillez sélectionner un rôle',
    'SELECT_TEAM': 'Veuillez sélectionner une équipe',
    'TEAM': 'Équipe',
    'T_END_DATE': "Date de fin d'essai",
    'USERNAME': "Nom d'utilisateur",
    'LAST_LOGIN': 'Dernière connexion'
  },
  'ACCOUNT': {
    'ADD_NEW': 'Ajouter un nouveau compte',
    'CURRENT_SALESFORCE_ORG': 'Organisation Salesforce actuelle:',
    'CURRENT_SALESFORCE_URL': 'URL',
    'NAME': 'Compte Nom ',
    'LIST': 'Compte Liste',
    'VALID_BLANK': 'Le nom du compte ne peut pas être vide',
    'VALID_EXIST': 'Le nom du compte existe déjà.',
    'VALID_MIN': 'Le nom du compte doit comporter au moins 5 caractères.',
    'ACCOUNT_TYPE': 'Type de compte',
    'OCR_ENGINE': 'Ocr Engine',
    'PROCESS_TYPE': 'Type de processus',
    'END_DATE': 'Date de fin',
    'VALID_OCR_ENGINE': 'Select an Ocr Engine.',
    'VALID_ACCOUNT_TYPE': 'Sélectionnez un type de compte.',
    'VALID_END_DATE': 'Fournissez une date de fin valide.',
    'VALID_EMAIL': 'Fournissez un email valide.',
    'VALID_PROCESS_TYPE': 'Sélectionnez au moins 1 type de processus.',
    'EDIT_ACCOUNT': 'Modifier le compte',
    'EMAIL': 'Email',
    'REASON': 'Raison',
    'ERRORS': 'LES ERREURS',
    'EMAIL_FORMAT': 'Format d\'email invalide.',
    'EMAIL_DIFF_ACC': 'Email utilisé avec un compte différent.',
    'UPLOAD_LOGO': 'Télécharger le logo',
    'ACCOUNT_LOGO': 'Logo du compte',
    'DELETE_CONTENT': 'Voulez-vous supprimer?'

  },
  'USER_DROPDOWN': {
    'PROFILE': 'Profil',
    'ADMINS': 'administrateurs',
    'LOGS': 'registre',
    'SETTINGS': 'réglages',
    'LOGOUT': 'déconnexion'
  },
  'FAB_TITLES': {
    'ADD_NEW_USER': 'ajouter un nouvel utilisateur',
    'ADD_TEMPLATE': 'ajouter un modèle',
    'EXPORT': 'exportation',
    'NEW_ACCOUNT': 'Nouveau compte',
    'UPLOAD_FORM': 'formulaire de téléchargement'
  },
  'ROUTE_NAME': {
    'Accounts': 'comptes',
    'Admin': 'Admin',
    'Users': 'Utilisateurs',
    'Add a New User': 'ajouter un nouvel utilisateur',
    'Add New Account': 'Ajouter un nouveau compte',
    'Configure': 'Configurer',
    'Dashboard': 'Tableau de bord',
    'Edit Account': 'Modifier le compte',
    'Edit User': 'Modifier l\'utilisateur',
    'Form Status': 'Statut du formulaire',
    'Log History': 'historique du journal',
    'New Template': 'Nouveau modèle',
    'Reports': 'rapports',
    'Register': 'enregistrer',
    'Template Listing': 'liste de modèle',
    'Train': 'former',
    'Sign In': 'Se connecter',
    'Upload Form': 'formulaire de téléchargement',
    'Form Doc': 'vérification',
    'Verification': 'vérification',
    'Forms': 'formes',
    'Reports Insights': 'Reports Insights',
    'My Profile': 'mon profil',
    'MODELS': 'DES MODÈLES',
    'page-not-found': '',
    'Features': 'Caractéristiques'
  },
  'PROFILE': {
    'ROLES': {
      'UNMATCHED': 'Incomparable',
      'SUPERADMIN': 'super administrateur',
      'ADMIN': 'administrateur',
      'TYPE_SELECT': 'sélectionnez le type de compte',
      'TRIAL': 'Compte d\'essai',
      'SUBS_ACC': 'Compte souscritmodifier'
    },
    'ACCNAME': {
      'DEFAULT': 'défaut'
    },
    'ACCOUNT_INFO': 'Information sur le compte',
    'ACCOUNT_SET': 'Paramètres du compte',
    'EMAIL_NOTIFY': 'Notifier lutilisateur par email',
    'ENTER_USER': "Entrez votre nom d'utilisateur",
    'ENTER_PASS': 'Entrez un nouveau mot de passe',
    'INFO': 'Informations sur le profil',
    'MEMBERS': 'Membres',
    'UPDATE_SUCCESS': 'Mise à jour du profil réussie',
    'WRONG_PASSWORD': 'Les informations d\'identification que vous avez fournies n\'étaient pas correctes'
  },
  'COMMON': {
    'GO_BACK': 'Retourner',
    'OKAY': "D'ACCORD",
    'FILE_ERROR': 'Erreur lors de l"analyse du fichier"',
    'PROCESS_ORDER_INFO': 'Docx utilise deux techniques pour trouver un modèle correspondant à un formulaire téléchargé. Ils sont Barcode et Image Match. La technique de code à barres est où le système cherche les modèles qui ont un type de code à barres similaire à celui du formulaire et Image Match est où il recherche des caractéristiques similaires entre les modèles et les images de formulaire. En fonction de l\'ordre de traitement, le système priorise la technique à utiliser. Par exemple, si l\'ordre de traitement du code à barres est 1, la technique du code à barres est privilégiée en premier lieu, puis la correspondance des images.',
    'MODEL_EXIST': 'Le nom du modèle existe déjà',
    'ADD_MODEL': 'Ajouter un nouveau modèle',
    'NEW_MODEL': 'Nouveau modèle',
    'VERSION': 'Version',
    'CHOOSE_FILE': 'Choisir le fichier',
    'ACCEPT': 'Acceptez',
    'ACCEPTED': 'Accepté',
    'ACCOUNT': 'Compte',
    'ACCOUNT_TYPE': 'Type de compte',
    'ACTION': 'Action',
    'ACTIONS': 'Actes',
    'ACTIVATE': 'Cliquez pour activer',
    'ADD': 'Ajouter',
    'ALERT': 'ALERTE',
    'APPROVE': 'Approuver',
    'CANCEL': 'Annuler',
    'CHANGE': 'Changement',
    'CLEAR': 'Clair',
    'CLOSE': 'Fermer',
    'CLONE': 'Cloner',
    'CONFIRM': 'Confirmation',
    'DATE_RANGE': 'Plage de dates',
    'DATE_START': 'Date de début',
    'DATE_END': 'Date de fin',
    'DAY': 'journée',
    'ESM': 'Les champs de modèle ne sont pas mappés avec l"objet Salesforce. Veuillez vérifier les paramètres',
    'TM': 'Les champs de modèle ne sont pas créés. Veuillez créer des champs dans le modèle',
    'DEACTIVATE': 'Cliquez pour désactiver',
    'DELETE': 'Effacer',
    'DELETE_CONFIRM': 'Eliminar confirmación',
    'DELETE_PERMANENTLY': 'supprimer définitivement',
    'DEL_AUTHCONFIG': 'Vous ne pouvez pas utiliser cet ID client et ce secret client après la suppression. Etes-vous sûr que vous voulez supprimer?',
    'DEL_AUTO_CORRECT': 'Cette action supprimera les fonctionnalités de correction automatique et lhistorique de ce champ. Etes-vous sûr que vous voulez supprimer?',
    'DEL_AUTO_CORRECT_HISTORY': 'Cette action supprimera tous les champs de correction automatique du dictionnaire. Etes-vous sûr que vous voulez supprimer?',
    'DEL_ORTFMAPPING': 'Cette action supprimera définitivement tous les mappages de champs ORTF de ce modèle. Etes-vous sûr que vous voulez supprimer?',
    'DEL_HL7MAPPING': 'Cette action supprimera définitivement tous les mappages de champs HL7 de ce modèle. Etes-vous sûr que vous voulez supprimer?',
    'DEL_SERVICEMAPPING': 'Cette action supprimera définitivement tous les mappages de champs externes de ce modèle. Etes-vous sûr que vous voulez supprimer?',
    'DEL_SERVICEVALIDATION': 'Cette action supprimera définitivement toutes les validations de service de ce modèle. Etes-vous sûr que vous voulez supprimer?',
    'DEL_CUSTOMVALIDATION': 'Cette action supprimera définitivement toutes les validations de service de ce modèle. Etes-vous sûr que vous voulez supprimer?',
    'QBS': 'Exporter vers QuickBooks',
    'SLSFRC': 'Exporter vers Salesforce',
    'REMS': 'Exporter vers Rems',
    'CSV': 'Télécharger en CSV',
    'HL7': 'Télécharger en HL7',
    'FTP': 'Télécharger en format FTP',
    'OTRF': 'Télécharger en format OTRF',
    'FILTER_BY': 'Filtrer par',
    'EHR': 'Exporter vers EHR',
    'FHIR': 'Voir les données FHIR',
    'EDT_USR': 'Modifier l\'utilisateur',
    'MSG_ERROR_DATE': 'Date invalide',
    'MSG_PERM': 'L\'utilisateur sera définitivement supprimé du système.',
    'MSG_PERM_DEL': 'Vous ne pouvez pas annuler cette action. Etes-vous sûr que vous voulez supprimer?',
    'MSG_DEL': 'Cette action supprimera les utilisateurs, rôles, modèles, formulaires, cartes de service, paramètres, etc. du compte.',
    'DESCRIPTION': 'Description',
    'DONE': 'Terminé',
    'EDIT': 'Modifier',
    'EXPIRES_AT': 'Expire à',
    'EXPORT': 'exportation',
    'FILE': 'Fichier',
    'FORM': 'Forme',
    'GENERATE': 'produire',
    'GROUP_NAME': 'Nom de groupe',
    'INTEGRATION_EMAILS': 'Courriels d\'intégration',
    'INVALID_FILE': 'Fichier non valide. (Le fichier doit être au format .jpg, .jpeg, .png, .pdf, .tiff)',
    'LIST': 'Liste',
    'MARK_VERIFIED': 'Mark vérifié',
    'MSG_CSV_LOG_DAYS': 'La plage maximale autorisée est dun mois',
    'MSG_CSV_LOG_DAYS_ERROR': 'Veuillez sélectionner moins de 31 jours',
    'MSG_EXPIRED': 'Session expirée, veuillez vous connecter pour continuer',
    'MSG_RETRY': 'Quelque chose a mal tourné. Veuillez réessayer',
    'MSG_REPROS': 'Le formulaire demandé est en cours de traitement.Veuillez patienter.',
    'MSG_DRAW': 'Activez s\'il vous plaît dessiner avant de créer des formes ...',
    'MSG_INACTIVE': 'Le service actuellement demandé n\'est pas actif. Désolé pour le dérangement.',
    'MSG_CREATE': 'Créé avec succès.',
    'MSG_UPDATE': 'Mise à jour réussie.',
    'MSG_DELETE': 'Supprimé avec succès.',
    'MSG_DELETE_HISTORY': 'Suppression réussie du dictionnaire',
    'MSG_DELETE_ERR': 'Erreur lors de la suppression. Veuillez réessayer.',
    'MSG_FIELD_DEL': 'La carte de terrain est supprimée',
    'MSG_LOGIN': 'Veuillez vous connecter pour accéder à la page demandée',
    'MSG_LOGIN_SUCESS': 'Connecté avec succès. Bienvenue ',
    'MSG_USER_NF': 'Utilisateur non trouvé!',
    'MSG_SERVER_UA': 'Serveur indisponible!',
    'MSG_LOGIN_FAIL': 'Quelque chose s\'est mal passé. La connexion a échoué',
    'MSG_LOGOUT': 'Déconnecté avec succès',
    'MSG_USER_UPDATE': 'Utilisateur mis à jour avec succès.',
    'MSG_SIGNUP_FAIL': 'Quelque chose s\'est mal passé. L\'inscription a échoué',
    'MSG_DATA_UPDATE': 'Données mises à jour avec succès',
    'MSG_USER_CREATE': 'Utilisateur créé avec succès.',
    'MSG_ERROR': 'Ocurrió un error. Inténtalo de nuevo.',
    'MSG_FORM_REQ': 'Soit vous n’avez pas accès au formulaire / formulaire demandé non trouvé.',
    'MSG_FETCH_ERR': 'Une erreur s\'est produite lors de la récupération des données de formulaire.',
    'MSG_PROCESS_FAIL': 'Échec du traitement, veuillez réessayer.',
    'MSG_FILE_LIMIT': 'La limite maximale de fichiers est de 5.',
    'MSG_TEMP_FILE_LIMIT': 'La limite maximale de fichiers est de 1.',
    'MSG_ACC_CREATE': 'Compte créé avec succès.',
    'MSG_SUCESS_ACC': 'Compte créé avec succès. Veuillez vous connecter',
    'MSG_EDIT_N_A': 'Non autorisé à modifier Admin',
    'MSG_ACC_SUCESS': 'Compte mis à jour avec succès.',
    'MSG_UPD_FAIL': 'Quelque chose s\'est mal passé. Mise à jour a échoué.',
    'MSG_REQ_FIELD': 'Ceci est un champ obligatoire',
    'MSG_KEY_UNIQUE': 'La clé doit être unique.',
    'MSG_SELECT_TYPE': 'Veuillez sélectionner le type',
    'MSG_SELECT_CHILD': 'Sélectionnez les enfants à supprimer avec le groupe:',
    'NAME': 'Prénom',
    'NEW': 'Nouveau',
    'NO': 'No',
    'ADD_NPI_GROUPING': 'Ajouter un groupement NPI',
    'NOTIFICATION_EMAILS': 'Emails de notification',
    'ENTER_MULTIPLE_EMAILS': 'Entrez un email séparé par des virgules',
    'NOTIFY_MSG': 'Vous avez {len} notifications',
    'NO_RECORD': "Il n'y a pas de disques à montrer",
    'OF': 'de',
    'PENDING': 'En attendant',
    'PROCESS': 'Processus',
    'PROCESSED': 'Traité',
    'PRESCRIBER_FIRST_NAME': 'Prénom du prescripteur',
    'PRESCRIBER_LAST_NAME': 'Nom de famille prescripteur',
    'PRESCRIBER_NAME': 'Nom du prescripteur',
    'REJECT': 'Rejeter',
    'REJECTED': 'Rejeté',
    'REQ_FIELD_WARNING': ' champs externes obligatoires à mapper',
    'RESET': 'Réinitialiser',
    'RESIZE': 'Redimensionner',
    'SELECT': 'Sélectionner',
    'SAVE': 'Sauvegarder',
    'SAVE_ALERT': 'Il y a des modifications non enregistrées, veuillez les enregistrer avant de partir.',
    'SHOW_TABLE': 'Afficher table',
    'STATUS': 'Statut',
    'SUBMIT': 'Soumettre',
    'TITLE': 'Nom du modèle',
    'UPDATE': 'Mettre à jour',
    'UPLOAD': 'Télécharger',
    'UNBLOCK': 'Débloquer',
    'UNMATCHED': 'Incomparable',
    'USERS': 'Utilisateurs',
    'VALIDATE_UPDATE': 'Valider et mettre à jour',
    'VERIFY': 'Vérifier',
    'VERIFY_DOCUMENT': 'Vérifier le document',
    'VERIFIED': 'Vérifié',
    'VIEW_FORMS': 'Voir les formulaires',
    'YES': 'Oui',
    'SUBSCRIBE': 'Souscrire',
    'UNSUBSCRIBE': 'Se désabonner',
    'UNAUTHORIZED': 'Non autorisé!',
    'UNMATCH': 'Le formulaire ne correspond à aucun modèle',
    'WEEK': 'la semaine',
    'ENTER_PASSWORD': 'Entrer le mot de passe',
    'WRONG_PASSWORD': 'Mauvais mot de passe',
    'Last Edited By': 'Last Edited By',
    'Enabled': 'Activé'
  },
  'PROCESS_ROLES': {
    'BARCODE': 'code à barre',
    'IMAGE_MATCH': 'Correspondance d\'image',
    'FORCE_TEMPLATE': 'Modèle de force',
    'PLAIN_TEXT': 'Texte brut'
  },
  'INVOICE': {
    'SIGN_INVOICE': 'SIGNER UNE FACTURE',
    'SIGN': 'Signe',
    'ACCOUNT': 'Compte',
    'ACCOUNTING_UNIT': 'Unité de comptabilité',
    'TOTAL_AMOUNT': 'Montant total',
    'ACC_REQ': 'Sélectionnez un compte',
    'ACC_UNIT_REQ': 'Sélectionnez une unité de comptabilité',
    'AMT_REQ': 'Le montant total est requis',
    'MIN_AMT': 'Le montant total doit être supérieur ou égal à zéro',
    'SIGN_SUCCESSFUL': 'Signé avec succès la facture',
    'APPROVAL_SUCCESSFUL': 'Approuvé avec succès la signature',
    'APPROVE_SIGN': 'APPROUVER LA VÉRIFICATION',
    'APPROVE': 'Approuver',
    'NOTES': 'Remarques'
  },
  'TEAMS': {
    'TEAM': 'Équipe',
    'TEAMS': 'Les équipes',
    'ADD_NEW_TEAM': 'Ajouter une nouvelle équipe',
    'CREATE_TEAM': 'Créer une équipe',
    'CREATE': 'Créer',
    'NAME': 'Nom',
    'DESCRIPTION': 'La description',
    'REQUIRED_FIELD': 'Champs requis',
    'NO_USER_FOUND': 'Aucun {ROLE} n\'a été trouvé. Veuillez ajouter un nouveau {ROLE}.',
    'NO_USER_ADDED': 'Aucun {ROLE} n\'a été ajouté à l\'équipe. Veuillez ajouter un {ROLE}.',
    'INCOMPLETE': 'L\'équipe est incomplète. Certains des rôles sont manquants dans la hiérarchie.',
    'DELETE_CONFIRM': 'Êtes-vous sûr de vouloir supprimer cette équipe de manière permanente?'
  },
  'Accounts': 'Comptes',
  'Add New': 'Ajouter un nouveau',
  'Add User': 'Ajouter un utilisateur',
  'Admin': 'Admin',
  'Admins': 'Les admins',
  'Aduit': 'Vérification',
  'Analytics': 'Analytique',
  'Configure': 'Configurer',
  'Forms': 'Formulaires',
  'Home': 'Accueil',
  'List': 'Liste',
  'Logs': 'Enregistrements',
  'New': 'Nouveau',
  'New User': 'Nouvel Utilisateur',
  'Processed': 'Traité',
  'Reports': 'Rapports',
  'Settings': 'Paramètres',
  'Models': 'Des modèles',
  'Super Admin': 'super administrateur',
  'Templates': 'Modèles',
  'Trails': 'Les sentiers',
  'Upload Form': 'formulaire de téléchargement',
  'Users': 'Utilisateurs',
  'Verification': 'Vérification',
  'Workflow': 'Flux de travail',
  'Mappings': 'Cartographies',
  'Add new mapping': 'Ajouter un nouveau mappage'
}



// WEBPACK FOOTER //
// ./src/lang/fr.js